<div class="recovery-dialog alt-justify-center">
  <h2 *ngIf="statusDetail =='error'"> {{"AUTH.mail-notsended" | translate}} </h2>
  <p *ngIf="statusDetail =='error'">{{"AUTH.mail-error-text" | translate}}</p>

  <h2 class=" alt-size-20  alt-inter-bold" *ngIf="statusDetail =='success'"> {{"AUTH.mail-sended" | translate}} </h2>
  <p class="alt-size-16 alt-inter-medium" *ngIf="statusDetail =='success'">{{"AUTH.check-email" | translate}}</p>

  <button *ngIf="statusDetail =='success'" type="button" class="button-confirm pointer" (click)="confirmButton(true)">
    {{"AUTH.confirm" | translate }}
  </button>
</div>
